var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"indicator":_vm.indicator,"inherited":_vm.isInherited}},[_c('dash-link',{attrs:{"to":_vm.to}},[_c('record-logo',{style:(_vm.style),attrs:{"item":_vm.item,"placeholder-disabled":_vm.placeholderDisabled}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }